import { render, staticRenderFns } from "./TipTapEditor.vue?vue&type=template&id=749659ac&scoped=true"
import script from "./TipTapEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TipTapEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TipTapEditor.vue?vue&type=style&index=0&id=749659ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749659ac",
  null
  
)

export default component.exports